/* 画像プレビュー画面 */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface Props {
  show: boolean;
  image_source: string;
  image_width: number;
  image_height: number;
  handleOnclick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PreviewModal: React.FC<Props> = ({
  show,
  image_source,
  image_width,
  image_height,
  handleOnclick,
}) => {
  return (
    <Modal id="PreviewModal" size="sm" centered show={show} animation={false}>
      <Button className="close-button" onClick={handleOnclick} />
      <img src={image_source} height={image_height} width={image_width} />
    </Modal>
  );
};

export default PreviewModal;
